<template>
  <vue-seamless-scroll
    :data="listData"
    :class-option="classOption"
    class="warp"
  >
    <ul class="item">
      <li v-for="(item, index) in listData" :key="index">
        <div class="content" >
          <div class="img-box">
          <img :src="item.HeadPic" width="30" height="30" />
        </div>
        <div class="sao-list-b ">
          <span style="color: #eb9904; ">{{ item.NickName }}</span>
          <span style="color: #ffffff; "
            >&nbsp;&nbsp; 供奉了{{ item.AppSacrifice.SacrificeName }}</span
          >
        </div>
        </div>
        <div class="mask" >&nbsp;</div>
        <!-- <span class="title" v-text="item.NickName"></span>
            <span class="date" v-text="item.Desc"></span> -->
      </li>
    </ul>
  </vue-seamless-scroll>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "Example01Basic",
  components: {
    vueSeamlessScroll,
  },
  props: {
    mid: String,
  },
  data() {
    return {
      listData: [],
      classOption: {
        singleHeight: 42,
      },
    };
  },
  methods: {
    getSacrificeLogList() {
      this.$store
        .dispatch({
          type: "GetSacrificeLogListByMid",
          mid: this.mid,
        })
        .then((res) => {
          //   console.log(res);
          this.listData = res;
        });
    },
  },
  watch: {
    mid: function(curVal, oldval) {
      if (curVal != oldval) {
        this.getSacrificeLogList();
      }
    },
  },
  created() {
    this.getSacrificeLogList();
  },
};
</script>

<style lang="less" scoped>
.warp {
  position: absolute;
  bottom: 115px;
  height: 125px;
  width: 360px;
  left: 5px;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    li {
      position: relative;
      width: 250px;
      height: 36px;
      // background-image: url("../assets/images/zy/list-bg.png");
      // background-repeat: no-repeat;
      font-size: 14px;
      margin-top: 6px;
      z-index: 100;
      background-size: contain;
      overflow: hidden;
      display: flex;
      align-items: center;
    }
    a {
      display: block;
      height: 30px;
      line-height: 30px;
      display: flex;
      justify-content: space-between;
      font-size: 15px;
    }
  }
  .mask{
    background-color: black;
    opacity: 0.5;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    border-radius: 17px;
  }
  .item {
    .content{
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 10;
   
    }
    .img-box {
      display: flex;
      align-items: center;
    }
    img {
      width: 35px;
      height: 35px;
      border-radius: 100px;
    }

    .sao-list-a img {
      width: 30px;
      height: 30px;
      border-radius: 100px;
    }

    .sao-list-b {
      position: absolute;
      left: 40px;
      top: 8px;
    }
  }
}
</style>
